import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.css';
import { oakland } from 'assets/icons';
import { useHistory } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import NextButton from 'layouts/RegistrationLayoutNew/Buttons/NextButton';

// main SelectClubSection component is below
const ClubCards = (
  data,
  selectedClub,
  setSelectedClub,
  onNext,
  loadSortedClubs,
  isMobile,
  isSmallMobile,
  isLargeMobile,
  handleFirstPageFlow,
  updateOlsTracking,
  trackingId,
  emailAddress,
  title,
  referralPerson,
  userExist
) => {
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const [selectedClubName, setSelectedClubName] = useState('');
  const history = useHistory();

  const handleMouseEnter = index => {
    setHoveredIndex(index);
  };
  const handleMouseLeave = () => {
    setHoveredIndex(-1);
  };

  const handleSelectClub = club => {
    const formattedName = formatGymName(club.displayName);
    if (isMobile) {
      setSelectedClub(club.clubautomationclubidC);
      setSelectedClubName(formattedName);
    } else {
      setSelectedClub(club.clubautomationclubidC);
      onNext();
      handleFirstPageFlow(true);
      if (trackingId) {
        handleTrackingApi(formattedName);
      }
      history.push(`/${formattedName}`);
    }
  };

  const handleTrackingApi = clubName => {
    const data = {
      session: trackingId,
      email: emailAddress,
      currentPage: title,
      data: JSON.stringify({ location: clubName }),
      isFormerMember: userExist,
      isReferral: Object.keys(referralPerson).length !== 0,
      referrerName: Object.keys(referralPerson).length !== 0 ? referralPerson.name : null,
      referrerCaid:
        Object.keys(referralPerson).length !== 0 ? referralPerson?.caID : null,
    };
    updateOlsTracking(data);
  };

  const formatGymName = name => {
    return name.toLowerCase().replace(/ /g, '-');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className={styles.main}>
        {data.length === 0 ? (
          <div>
            <CircularProgress
              className={styles.circularProgress}
              style={{ color: '#fe5000' }}
            />
          </div>
        ) : (
          <>
            {data?.map((club, i) => {
              return (
                <>
                  <div
                    onClick={() => {
                      handleSelectClub(club);
                    }}
                    id={club.clubautomationclubidC}
                    key={club.clubautomationclubidC}
                    className={`${styles.card}  }`}
                  >
                    <div
                      className={`${styles.backgroundImg} ${isMobile &&
                        selectedClub === club.clubautomationclubidC &&
                        styles.activeCard} `}
                    >
                      <div
                        className={`${styles.backgroundImage} `}
                        onMouseEnter={() => handleMouseEnter(i)}
                        onMouseLeave={handleMouseLeave}
                        style={{
                          backgroundImage: `url(${
                            i === hoveredIndex
                              ? oakland
                              : !isMobile
                              ? club.olsBgDesktop
                              : club.olsBgMobile
                          })`,
                        }}
                      >
                        <div
                          className={`${styles.overlay} ${
                            isMobile ? styles.mobile : ''
                          } ${isSmallMobile ? styles.smallMob : ''} ${
                            isLargeMobile ? styles.largeMob : ''
                          }`}
                        >
                          <h1
                            className={`${styles.clubName} ${
                              isMobile ? styles.mobile : ''
                            } ${isSmallMobile ? styles.smallMob : ''} ${
                              isLargeMobile ? styles.largeMob : ''
                            }`}
                          >
                            {club.displayName}
                          </h1>
                          <p
                            className={`${styles.clubDistance} ${
                              isMobile ? styles.mobile : ''
                            } ${isSmallMobile ? styles.smallMob : ''} ${
                              isLargeMobile ? styles.largeMob : ''
                            }`}
                          >
                            {' '}
                            {i === hoveredIndex ? (
                              isMobile ? (
                                <>
                                  <p>{club.streetC} </p>
                                  <p className={styles.city}> {club.cityC}</p>
                                </>
                              ) : (
                                club.streetC + ' , ' + club.cityC
                              )
                            ) : club.miles !== null ? (
                              club.miles + ' miles away '
                            ) : null}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
            {isMobile ? (
              <>
                <div className={styles.scroll}></div>
                <NextButton
                  onNext={() => {
                    onNext();
                    handleFirstPageFlow(true);
                    if (trackingId) {
                      handleTrackingApi(selectedClubName);
                    }
                    history.push(`/${selectedClubName}`);
                  }}
                  disabled={selectedClub == null}
                  nextButtonName="Select"
                />
              </>
            ) : null}
          </>
        )}
      </div>
    </>
  );
};

const SelectClubSection = ({
  clubs,
  selectedClub,
  setSelectedClub,
  onNext,
  loadSortedClubs,
  isMobile,
  isSmallMobile,
  isLargeMobile,
  handleFirstPageFlow,
  updateOlsTracking,
  trackingId,
  emailAddress,
  title,
  referralPerson,
  userExist,
}) => {
  return (
    <>
      {ClubCards(
        clubs,
        selectedClub,
        setSelectedClub,
        onNext,
        loadSortedClubs,
        isMobile,
        isSmallMobile,
        isLargeMobile,
        handleFirstPageFlow,
        updateOlsTracking,
        trackingId,
        emailAddress,
        title,
        referralPerson,
        userExist
      )}
    </>
  );
};

SelectClubSection.propTypes = {
  clubs: PropTypes.array.isRequired,
  selectedClub: PropTypes.string.isRequired,
  setSelectedClub: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default SelectClubSection;
